import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import {autoRehydrate} from 'redux-persist';
import rootSaga from './saga';
import rootReducer from './reducer';
import { composeWithDevTools } from 'redux-devtools-extension';
import { jwtMiddleware } from 'Auth/authenticator';

export default function ConfigureStore() {

  const sagaMiddleware = createSagaMiddleware();

  const composeEnhancers = composeWithDevTools({
  //   // Specify name here, actionsBlacklist, actionsCreators and other options if needed
  });

  const store = createStore(rootReducer,
    composeEnhancers(autoRehydrate(), applyMiddleware(jwtMiddleware, sagaMiddleware),
    //applyMiddleware(sagaMiddleware),
    // other store enhancers if any
    ));

  sagaMiddleware.run(rootSaga);

  return store;
}



// WEBPACK FOOTER //
// ./src/portal_system/configure-store.js